import { Navigate, useNavigate, useLocation } from "react-router";
import { routes } from "@routes";
import { useEffect } from "react";
import { Spinner } from "@thetreep/ui";
import { Role } from "@gen/user/v1/user_pb";
import { useUserStore } from "@stores/userStore";

export function ProtectedRoute({
  roles,
  children,
}: {
  roles?: Role[];
  children: React.ReactNode;
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, isInitialized } = useUserStore();
  const isConfirmationRoute = location.pathname === routes.CONFIRMATION;

  useEffect(() => {
    if (
      isInitialized &&
      !user &&
      !isConfirmationRoute &&
      location.pathname !== routes.LOGIN
    ) {
      navigate(routes.LOGIN);
    }
  }, [user, isInitialized, navigate, location.pathname, isConfirmationRoute]);

  if (!isConfirmationRoute && (!isInitialized || !user)) {
    return (
      <div className="w-full h-full flex items-center justify-center">
        <Spinner />
      </div>
    );
  }

  if (!!roles && user && !roles.includes(user.role)) {
    return <Navigate to={"/"} />;
  }

  return <>{children}</>;
}
